module.exports = __webpack_public_path__ + "img/AL271-1.3bd0bd72.jpg";